export const data = {
	data() {
		return {
			headerList: [
                {
					prop: 'id',
					label: 'ID',
					width: 80
				},
				{
					prop: 'shop',
					label: '商品',
					width: 260
				},
                {
					prop: 'title',
					label: '关联课程',
					width: 160
				},
				{
					prop: 'goods_share_text',
					label: '商品口令',
					width: 220
				},
				{
					prop: 'created_time',
					label: '添加时间',
					width: 160
				}
			]
		}
	}
}